"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateBgContactBar = void 0;
var _gerenciatdUtils = require("@bit/gerenciatd.utils.style-utils");
const generateBgContactBar = (idContactBar, bgImage) => {
  if (idContactBar && bgImage) {
    const bgImageUrl = `url(${bgImage})`;
    (0, _gerenciatdUtils.addMediaQuery)(`#${idContactBar}`, `background-image: ${bgImageUrl};
        background-size: cover;`);
  }
};
exports.generateBgContactBar = generateBgContactBar;

//# sourceMappingURL=contactBarUtils.js.map